<div class="p-d-flex p-jc-between border-bottom">
  <div class="p-d-inline-flex p-mx-3">
    <h3 class="p-mt-4 p-mr-4">My News Feed</h3>
    <p class="p-mt-5">
      Recent coverage of topics you follow.
    </p>
  </div>
  <div class="p-d-inline-flex p-my-3 p-mx-3">
    <div class="">
      <p-button
        pRipple
        styleClass="p-button-secondary newFeedColor force-pointer p-button-sm p-mr-1"
        icon="pi pi-filter"
        label="Search Filters"
        (click)="toggleModal()"
        [pTooltip]="!isSidebarVisible ? '' : 'Search Filters'"
      ></p-button>
      <p-button
        pRipple
        styleClass="p-button-secondary newFeedColor force-pointer p-button-sm p-mr-1"
        icon="pi pi-file-excel"
        label="Export My News Feed"
        (click)="handleExportToExcel()"
        [loading]="isExportingExcel"
        [disabled]="isExportingExcel"
      ></p-button>
      <p-button
        *ngIf="isAdmin()"
        pRipple
        styleClass="p-button-secondary newFeedColor force-pointer p-button-sm p-mr-2"
        icon="pi pi-file"
        label="Dump Content"
        (click)="handleExportToText()"
        [loading]="isExportingText"
        [disabled]="isExportingText"
      ></p-button>
    </div>
    <div id="showQ" class="p-px-1">
      <div *ngIf="isAdmin(); then showQueryContent"></div>
      <ng-template #showQueryContent>
        <p-button
          id="btnShowQuery"
          #btnShowQuery
          pRipple
          icon="pi pi-search"
          (click)="handleShowQuery($event)"
          label="View Queries"
          styleClass="p-button-secondary newFeedColor p-button-sm"
        ></p-button>
        <p-overlayPanel
          #opShowQuery
          [dismissable]="true"
          [style]="{ width: '60%' }"
          appendTo="body"
        >
          <div class="p-formgroup-inline">
            <div class="p-m-2">Authors</div>
            <div class="p-field" style="flex-grow: 1; margin-right: 10px">
              <input
                type="text"
                pInputText
                placeholder="Query"
                [(ngModel)]="authorsQuery"
                style="width: 100%"
              />
            </div>
            <button
              pButton
              pRipple
              type="button"
              label=""
              pTooltip="copy-to-clipboard"
              (click)="handleCopyQuery(authorsQuery)"
              class="p-button-secondary p-button-sm"
              icon="pi pi-clone"
            ></button>
          </div>
          <div class="p-formgroup-inline">
            <div class="p-m-2">Topics</div>
            <div class="p-field" style="flex-grow: 1; margin-right: 10px">
              <input
                type="text"
                pInputText
                placeholder="Query"
                [(ngModel)]="topicsQuery"
                style="width: 100%"
              />
            </div>
            <button
              pButton
              pRipple
              type="button"
              label=""
              pTooltip="copy-to-clipboard"
              (click)="handleCopyQuery(topicsQuery)"
              class="p-button-secondary p-button-sm"
              icon="pi pi-clone"
            ></button>
          </div>
          <div class="p-formgroup-inline">
            <div class="p-m-2">Outlets</div>
            <div class="p-field" style="flex-grow: 1; margin-right: 10px">
              <input
                type="text"
                pInputText
                placeholder="Query"
                [(ngModel)]="outletsQuery"
                style="width: 100%"
              />
            </div>
            <button
              pButton
              pRipple
              type="button"
              label=""
              pTooltip="copy-to-clipboard"
              (click)="handleCopyQuery(outletsQuery)"
              class="p-button-secondary p-button-sm"
              icon="pi pi-clone"
            ></button>
          </div>
          <div class="p-formgroup-inline">
            <div class="p-m-2">Articles</div>
            <div class="p-field" style="flex-grow: 1; margin-right: 10px">
              <input
                type="text"
                pInputText
                placeholder="Query"
                [(ngModel)]="contentItemsQuery"
                style="width: 100%"
              />
            </div>
            <button
              pButton
              pRipple
              type="button"
              label=""
              pTooltip="copy-to-clipboard"
              (click)="handleCopyQuery(contentItemsQuery)"
              class="p-button-secondary p-button-sm"
              icon="pi pi-clone"
            ></button>
          </div>
        </p-overlayPanel>
      </ng-template>
    </div>
  </div>
</div>
<app-loading [isLoading]="isLoadingContent"></app-loading>
<div class="p-px-2">
  <app-content-items
    [parentName]="parentName"
    [items]="feeds"
    [loading]="loading"
    [pageSize]="pageSize"
    [page]="page"
    [total]="total"
  ></app-content-items>
  <div class="p-d-flex p-jc-between" style="border-top: 'solid 0.5px #f0f0f0'">
    <div>
      <p-paginator
        *ngIf="totalPages >= 2"
        #pp
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ total | number }} total items"
        [pageLinkSize]="3"
        [showFirstLastIcon]="false"
        (onPageChange)="getPage($event)"
        [rows]="pageSize"
        [totalRecords]="total"
      >
      </p-paginator>
    </div>
    <div class="p-mt-2" *ngIf="hideSort">
      <app-sort-options
        (sortChangesEmiter)="sortChange($event)"
        [defaultSort]="sortSelected"
      ></app-sort-options>
    </div>
  </div>
</div>
<app-advanced-search
  [reset]="onResetFilter"
  [visible]="showFilters"
  [keywords]=""
  (toggle)="handleVisible($event)"
  (newsFeedFilters)="handleNewsFeedwithFilters($event)"
  [setSearchFromTypeahead]=""
  [filterType]="'NEWS_FEED'"
>
</app-advanced-search>
